export const planFeatures = [
  { id: 'anonymity', textKey: 'featureFullAnonymity' },
  { id: 'compliance', textKey: 'featureCompliance' },
  { id: 'localization', textKey: 'featureLocalization' },
  { id: 'followUp', textKey: 'featureFollowUp' },
  { id: 'configurations', textKey: 'featureConfigurations' },
  { id: 'userRoles', textKey: 'featureUserRoles' },
  { id: 'identityProtection', textKey: 'featureIdentityProtection' },
  { id: 'reportsManagement', textKey: 'featureReportsManagement' },
  { id: 'customLogo', textKey: 'featureCustomLogo' },
  { id: 'customerSupport', textKey: 'featureCustomerSupport' },
  { id: 'attachments', textKey: 'featureAttachments' },
];

export type PricingFeatureKey = (typeof planFeatures)[number]['textKey'];
